import request from '@/utils/request'

// api地址
const api = {
  list: 'user/getRoomList',
  statePowerRoom: 'cleaner/powerroom',
  openRoom: 'cleaner/openroom',
  openDoor: 'cleaner/openDoor',
}

// 列表
export const list = (data) => {
  return request.post(api.list, data)
}

export function statePowerRoom (data) {
  return request.post(api.statePowerRoom, data)
}

export function openRoom (params) {
  return request.get(api.openRoom, params)
}

export function openDoor (params) {
  return request.get(api.openDoor, params)
}
